import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield as ShieldIcon, FileText as FileTextIcon, Cookie as CookieIcon, Lock as LockIcon, ChevronDown as ChevronDownIcon, ChevronUp as ChevronUpIcon, Mail as MailIcon, Smartphone as SmartphoneIcon, CreditCard as CreditCardIcon } from 'lucide-react';
import { Button } from '../components/Button';
export function TermsAndPrivacy() {
  const [activeTab, setActiveTab] = useState<'terms' | 'privacy' | 'cookies'>('terms');
  const [expandedSection, setExpandedSection] = useState<number | null>(null);
  const toggleSection = (sectionId: number) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };
  return <main className="py-16 w-full bg-[#F9FAFB]" data-id="element-1392">
      <div className="container mx-auto px-4" data-id="element-1393">
        <div className="text-center mb-12" data-id="element-1394">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1395">Legal Information</h1>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1396">
            Our terms, privacy policy, and cookie policy outline how we provide
            our services, protect your data, and ensure a secure experience.
          </p>
        </div>
        {/* Tabs */}
        <div className="flex justify-center mb-10" data-id="element-1397">
          <div className="inline-flex rounded-lg border border-gray-200 bg-white p-1" data-id="element-1398">
            <button className={`px-4 py-2 rounded-md font-medium flex items-center ${activeTab === 'terms' ? 'bg-[#2563EB] text-white' : 'text-gray-600'}`} onClick={() => setActiveTab('terms')} data-id="element-1399">
              <FileTextIcon className="w-4 h-4 mr-2" data-id="element-1400" />
              Terms of Service
            </button>
            <button className={`px-4 py-2 rounded-md font-medium flex items-center ${activeTab === 'privacy' ? 'bg-[#2563EB] text-white' : 'text-gray-600'}`} onClick={() => setActiveTab('privacy')} data-id="element-1401">
              <ShieldIcon className="w-4 h-4 mr-2" data-id="element-1402" />
              Privacy Policy
            </button>
            <button className={`px-4 py-2 rounded-md font-medium flex items-center ${activeTab === 'cookies' ? 'bg-[#2563EB] text-white' : 'text-gray-600'}`} onClick={() => setActiveTab('cookies')} data-id="element-1403">
              <CookieIcon className="w-4 h-4 mr-2" data-id="element-1404" />
              Cookie Policy
            </button>
          </div>
        </div>
        {/* Content */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-16" data-id="element-1405">
          {activeTab === 'terms' && <div data-id="element-1406">
              <div className="mb-8" data-id="element-1407">
                <h2 className="text-2xl font-bold mb-4" data-id="element-1408">Terms of Service</h2>
                <p className="text-gray-600 mb-4" data-id="element-1409">
                  Last updated: January 15, 2023
                </p>
                <p className="text-gray-600" data-id="element-1410">
                  Please read these Terms of Service carefully before using our
                  eSIM services. By accessing or using TravelSIM, you agree to
                  be bound by these terms and conditions.
                </p>
              </div>
              <div className="space-y-4" data-id="element-1411">
                <div className="border border-gray-200 rounded-lg" data-id="element-1412">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(1)} data-id="element-1413">
                    <h3 className="font-semibold text-lg" data-id="element-1414">
                      1. Acceptance of Terms
                    </h3>
                    {expandedSection === 1 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1415" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1416" />}
                  </button>
                  {expandedSection === 1 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1417">
                      <p className="text-gray-600 mb-4" data-id="element-1418">
                        By accessing or using our services, you acknowledge that
                        you have read, understood, and agree to be bound by
                        these Terms of Service. If you do not agree to these
                        terms, please do not use our services.
                      </p>
                      <p className="text-gray-600" data-id="element-1419">
                        We reserve the right to modify these terms at any time.
                        Your continued use of our services following the posting
                        of changes constitutes your acceptance of such changes.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1420">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(2)} data-id="element-1421">
                    <h3 className="font-semibold text-lg" data-id="element-1422">
                      2. Service Description
                    </h3>
                    {expandedSection === 2 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1423" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1424" />}
                  </button>
                  {expandedSection === 2 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1425">
                      <p className="text-gray-600 mb-4" data-id="element-1426">
                        TravelSIM provides eSIM services that allow users to
                        connect to mobile networks in various countries without
                        the need for a physical SIM card. Our services include
                        data plans for international travel with varying data
                        allowances and validity periods.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1427">
                        The quality and availability of our services may vary by
                        location and are subject to the coverage and
                        capabilities of our partner networks. We do not
                        guarantee continuous or error-free service.
                      </p>
                      <p className="text-gray-600" data-id="element-1428">
                        Our services are primarily intended for temporary travel
                        use and not as a replacement for regular domestic mobile
                        service.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1429">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(3)} data-id="element-1430">
                    <h3 className="font-semibold text-lg" data-id="element-1431">
                      3. User Eligibility and Account
                    </h3>
                    {expandedSection === 3 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1432" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1433" />}
                  </button>
                  {expandedSection === 3 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1434">
                      <p className="text-gray-600 mb-4" data-id="element-1435">
                        To use our services, you must be at least 18 years old
                        or the legal age of majority in your jurisdiction. By
                        using our services, you represent and warrant that you
                        meet these eligibility requirements.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1436">
                        You are responsible for maintaining the confidentiality
                        of your account information, including your password,
                        and for all activity that occurs under your account. You
                        agree to notify us immediately of any unauthorized use
                        of your account.
                      </p>
                      <p className="text-gray-600" data-id="element-1437">
                        We reserve the right to terminate or suspend your
                        account at our discretion, without notice, for conduct
                        that we believe violates these Terms of Service or is
                        harmful to other users, us, or third parties, or for any
                        other reason.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1438">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(4)} data-id="element-1439">
                    <h3 className="font-semibold text-lg" data-id="element-1440">
                      4. Payment and Billing
                    </h3>
                    {expandedSection === 4 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1441" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1442" />}
                  </button>
                  {expandedSection === 4 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1443">
                      <p className="text-gray-600 mb-4" data-id="element-1444">
                        All prices for our services are displayed in USD unless
                        otherwise specified. Prices are subject to change, but
                        changes will not affect orders already placed and
                        confirmed.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1445">
                        Payment must be made at the time of purchase. We accept
                        various payment methods as indicated on our website. By
                        providing payment information, you represent and warrant
                        that you are authorized to use the payment method.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1446">
                        Subscriptions will automatically renew unless canceled
                        before the renewal date. You can cancel your
                        subscription at any time through your account settings.
                      </p>
                      <p className="text-gray-600" data-id="element-1447">
                        For our refund policy, please refer to our{' '}
                        <Link to="/refund-policy" className="text-blue-600 hover:underline" data-id="element-1448">
                          Refund Policy
                        </Link>{' '}
                        page.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1449">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(5)} data-id="element-1450">
                    <h3 className="font-semibold text-lg" data-id="element-1451">
                      5. Limitations of Use
                    </h3>
                    {expandedSection === 5 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1452" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1453" />}
                  </button>
                  {expandedSection === 5 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1454">
                      <p className="text-gray-600 mb-4" data-id="element-1455">
                        You agree not to use our services for any illegal or
                        unauthorized purpose. You must comply with all local
                        laws regarding online conduct and acceptable content.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1456">
                        You may not use our services to:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1457">
                        <li data-id="element-1458">Violate any laws or regulations</li>
                        <li data-id="element-1459">Infringe upon the rights of others</li>
                        <li data-id="element-1460">Distribute malware or other harmful code</li>
                        <li data-id="element-1461">
                          Interfere with or disrupt our services or servers
                        </li>
                        <li data-id="element-1462">
                          Engage in any activity that could damage, disable, or
                          impair our services
                        </li>
                        <li data-id="element-1463">
                          Resell or redistribute our services without our
                          explicit permission
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1464">
                        We reserve the right to terminate your access to our
                        services for violation of these limitations.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1465">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(6)} data-id="element-1466">
                    <h3 className="font-semibold text-lg" data-id="element-1467">
                      6. Intellectual Property
                    </h3>
                    {expandedSection === 6 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1468" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1469" />}
                  </button>
                  {expandedSection === 6 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1470">
                      <p className="text-gray-600 mb-4" data-id="element-1471">
                        All content, features, and functionality of our
                        services, including but not limited to text, graphics,
                        logos, icons, images, audio clips, digital downloads,
                        and software, are the exclusive property of TravelSIM or
                        our licensors and are protected by copyright, trademark,
                        and other intellectual property laws.
                      </p>
                      <p className="text-gray-600" data-id="element-1472">
                        You may not reproduce, distribute, modify, create
                        derivative works of, publicly display, publicly perform,
                        republish, download, store, or transmit any of our
                        materials without our express written consent.
                      </p>
                    </div>}
                </div>
              </div>
            </div>}
          {activeTab === 'privacy' && <div data-id="element-1473">
              <div className="mb-8" data-id="element-1474">
                <h2 className="text-2xl font-bold mb-4" data-id="element-1475">Privacy Policy</h2>
                <p className="text-gray-600 mb-4" data-id="element-1476">
                  Last updated: January 15, 2023
                </p>
                <p className="text-gray-600" data-id="element-1477">
                  At TravelSIM, we take your privacy seriously. This Privacy
                  Policy explains how we collect, use, disclose, and safeguard
                  your information when you use our eSIM services.
                </p>
              </div>
              <div className="space-y-4" data-id="element-1478">
                <div className="border border-gray-200 rounded-lg" data-id="element-1479">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(1)} data-id="element-1480">
                    <h3 className="font-semibold text-lg" data-id="element-1481">
                      1. Information We Collect
                    </h3>
                    {expandedSection === 1 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1482" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1483" />}
                  </button>
                  {expandedSection === 1 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1484">
                      <p className="text-gray-600 mb-4" data-id="element-1485">
                        We collect several types of information from and about
                        users of our services, including:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1486">
                        <li data-id="element-1487">
                          <strong data-id="element-1488">Personal Information:</strong> Name, email
                          address, postal address, phone number, and payment
                          information.
                        </li>
                        <li data-id="element-1489">
                          <strong data-id="element-1490">Usage Data:</strong> Information about how you
                          use our services, including data consumption,
                          connection times, and locations.
                        </li>
                        <li data-id="element-1491">
                          <strong data-id="element-1492">Device Information:</strong> Information about
                          your device, including device type, operating system,
                          browser type, and IP address.
                        </li>
                        <li data-id="element-1493">
                          <strong data-id="element-1494">Location Data:</strong> General location
                          information based on IP address or more precise
                          location if you enable location services.
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1495">
                        We collect this information directly from you when you
                        provide it to us, automatically as you navigate through
                        our services, and from third parties such as our payment
                        processors and network providers.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1496">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(2)} data-id="element-1497">
                    <h3 className="font-semibold text-lg" data-id="element-1498">
                      2. How We Use Your Information
                    </h3>
                    {expandedSection === 2 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1499" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1500" />}
                  </button>
                  {expandedSection === 2 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1501">
                      <p className="text-gray-600 mb-4" data-id="element-1502">
                        We use the information we collect about you for various
                        purposes, including:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1503">
                        <li data-id="element-1504">Providing and maintaining our services</li>
                        <li data-id="element-1505">Processing and completing transactions</li>
                        <li data-id="element-1506">
                          Managing your account and providing customer support
                        </li>
                        <li data-id="element-1507">
                          Sending you technical notices, updates, and
                          administrative messages
                        </li>
                        <li data-id="element-1508">
                          Improving our services and developing new features
                        </li>
                        <li data-id="element-1509">Analyzing usage patterns and trends</li>
                        <li data-id="element-1510">
                          Detecting, preventing, and addressing technical issues
                          and fraudulent activities
                        </li>
                        <li data-id="element-1511">Complying with legal obligations</li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1512">
                        With your consent, we may also use your information to
                        send you marketing communications about our products and
                        services. You can opt out of these communications at any
                        time.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1513">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(3)} data-id="element-1514">
                    <h3 className="font-semibold text-lg" data-id="element-1515">
                      3. Information Sharing and Disclosure
                    </h3>
                    {expandedSection === 3 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1516" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1517" />}
                  </button>
                  {expandedSection === 3 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1518">
                      <p className="text-gray-600 mb-4" data-id="element-1519">
                        We may share your information in the following
                        circumstances:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1520">
                        <li data-id="element-1521">
                          <strong data-id="element-1522">With Service Providers:</strong> We share
                          information with third-party vendors, consultants, and
                          other service providers who need access to such
                          information to carry out work on our behalf.
                        </li>
                        <li data-id="element-1523">
                          <strong data-id="element-1524">With Network Partners:</strong> We share
                          information with our network partners to provide
                          connectivity services in various countries.
                        </li>
                        <li data-id="element-1525">
                          <strong data-id="element-1526">For Legal Reasons:</strong> We may disclose
                          information if required to do so by law or in response
                          to valid requests by public authorities.
                        </li>
                        <li data-id="element-1527">
                          <strong data-id="element-1528">Business Transfers:</strong> If we are
                          involved in a merger, acquisition, or sale of all or a
                          portion of our assets, your information may be
                          transferred as part of that transaction.
                        </li>
                        <li data-id="element-1529">
                          <strong data-id="element-1530">With Your Consent:</strong> We may share your
                          information with third parties when you have given us
                          your consent to do so.
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1531">
                        We do not sell your personal information to third
                        parties.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1532">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(4)} data-id="element-1533">
                    <h3 className="font-semibold text-lg" data-id="element-1534">4. Data Security</h3>
                    {expandedSection === 4 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1535" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1536" />}
                  </button>
                  {expandedSection === 4 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1537">
                      <p className="text-gray-600 mb-4" data-id="element-1538">
                        We implement appropriate technical and organizational
                        measures to protect your personal information against
                        unauthorized or unlawful processing, accidental loss,
                        destruction, or damage.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1539">
                        These measures include:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1540">
                        <li data-id="element-1541">Encryption of sensitive data</li>
                        <li data-id="element-1542">Regular security assessments and audits</li>
                        <li data-id="element-1543">Access controls and authentication procedures</li>
                        <li data-id="element-1544">Secure network architecture and monitoring</li>
                        <li data-id="element-1545">
                          Employee training on data protection and security
                          practices
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1546">
                        However, no method of transmission over the Internet or
                        electronic storage is 100% secure. While we strive to
                        use commercially acceptable means to protect your
                        personal information, we cannot guarantee its absolute
                        security.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1547">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(5)} data-id="element-1548">
                    <h3 className="font-semibold text-lg" data-id="element-1549">
                      5. Your Rights and Choices
                    </h3>
                    {expandedSection === 5 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1550" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1551" />}
                  </button>
                  {expandedSection === 5 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1552">
                      <p className="text-gray-600 mb-4" data-id="element-1553">
                        Depending on your location, you may have certain rights
                        regarding your personal information, including:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1554">
                        <li data-id="element-1555">
                          <strong data-id="element-1556">Access:</strong> You can request access to
                          your personal information that we hold.
                        </li>
                        <li data-id="element-1557">
                          <strong data-id="element-1558">Correction:</strong> You can request that we
                          correct inaccurate or incomplete information.
                        </li>
                        <li data-id="element-1559">
                          <strong data-id="element-1560">Deletion:</strong> You can request that we
                          delete your personal information in certain
                          circumstances.
                        </li>
                        <li data-id="element-1561">
                          <strong data-id="element-1562">Restriction:</strong> You can request that we
                          restrict the processing of your information in certain
                          circumstances.
                        </li>
                        <li data-id="element-1563">
                          <strong data-id="element-1564">Data Portability:</strong> You can request a
                          copy of your information in a structured, commonly
                          used, and machine-readable format.
                        </li>
                        <li data-id="element-1565">
                          <strong data-id="element-1566">Objection:</strong> You can object to our
                          processing of your information in certain
                          circumstances.
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1567">
                        To exercise these rights, please contact us using the
                        contact information provided at the end of this policy.
                        We will respond to your request within a reasonable
                        timeframe.
                      </p>
                    </div>}
                </div>
              </div>
            </div>}
          {activeTab === 'cookies' && <div data-id="element-1568">
              <div className="mb-8" data-id="element-1569">
                <h2 className="text-2xl font-bold mb-4" data-id="element-1570">Cookie Policy</h2>
                <p className="text-gray-600 mb-4" data-id="element-1571">
                  Last updated: January 15, 2023
                </p>
                <p className="text-gray-600" data-id="element-1572">
                  This Cookie Policy explains how TravelSIM uses cookies and
                  similar technologies to recognize you when you visit our
                  website. It explains what these technologies are and why we
                  use them, as well as your rights to control our use of them.
                </p>
              </div>
              <div className="space-y-4" data-id="element-1573">
                <div className="border border-gray-200 rounded-lg" data-id="element-1574">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(1)} data-id="element-1575">
                    <h3 className="font-semibold text-lg" data-id="element-1576">
                      1. What Are Cookies?
                    </h3>
                    {expandedSection === 1 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1577" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1578" />}
                  </button>
                  {expandedSection === 1 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1579">
                      <p className="text-gray-600 mb-4" data-id="element-1580">
                        Cookies are small data files that are placed on your
                        computer or mobile device when you visit a website.
                        Cookies are widely used by website owners to make their
                        websites work, or to work more efficiently, as well as
                        to provide reporting information.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1581">
                        Cookies set by the website owner (in this case,
                        TravelSIM) are called "first-party cookies." Cookies set
                        by parties other than the website owner are called
                        "third-party cookies." Third-party cookies enable
                        third-party features or functionality to be provided on
                        or through the website (e.g., advertising, interactive
                        content, and analytics).
                      </p>
                      <p className="text-gray-600" data-id="element-1582">
                        Cookies can be "persistent" or "session" cookies.
                        Persistent cookies remain on your device after you close
                        your browser until they expire or you delete them.
                        Session cookies are deleted as soon as you close your
                        browser.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1583">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(2)} data-id="element-1584">
                    <h3 className="font-semibold text-lg" data-id="element-1585">
                      2. Types of Cookies We Use
                    </h3>
                    {expandedSection === 2 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1586" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1587" />}
                  </button>
                  {expandedSection === 2 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1588">
                      <p className="text-gray-600 mb-4" data-id="element-1589">
                        We use the following types of cookies:
                      </p>
                      <ul className="list-disc pl-5 mb-4 text-gray-600" data-id="element-1590">
                        <li data-id="element-1591">
                          <strong data-id="element-1592">Essential Cookies:</strong> These cookies are
                          necessary for the website to function properly and
                          cannot be switched off in our systems. They are
                          usually only set in response to actions made by you
                          which amount to a request for services, such as
                          setting your privacy preferences, logging in, or
                          filling in forms.
                        </li>
                        <li data-id="element-1593">
                          <strong data-id="element-1594">Performance Cookies:</strong> These cookies
                          allow us to count visits and traffic sources so we can
                          measure and improve the performance of our site. They
                          help us to know which pages are the most and least
                          popular and see how visitors move around the site.
                        </li>
                        <li data-id="element-1595">
                          <strong data-id="element-1596">Functional Cookies:</strong> These cookies
                          enable the website to provide enhanced functionality
                          and personalization. They may be set by us or by
                          third-party providers whose services we have added to
                          our pages.
                        </li>
                        <li data-id="element-1597">
                          <strong data-id="element-1598">Targeting Cookies:</strong> These cookies may
                          be set through our site by our advertising partners.
                          They may be used by those companies to build a profile
                          of your interests and show you relevant advertisements
                          on other sites.
                        </li>
                      </ul>
                      <p className="text-gray-600" data-id="element-1599">
                        We also use other tracking technologies like web beacons
                        (sometimes called "tracking pixels" or "clear gifs").
                        These are tiny graphics files that contain a unique
                        identifier that enable us to recognize when someone has
                        visited our website or opened an email that we have sent
                        them.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1600">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(3)} data-id="element-1601">
                    <h3 className="font-semibold text-lg" data-id="element-1602">
                      3. How Can You Control Cookies?
                    </h3>
                    {expandedSection === 3 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1603" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1604" />}
                  </button>
                  {expandedSection === 3 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1605">
                      <p className="text-gray-600 mb-4" data-id="element-1606">
                        You can set or amend your web browser controls to accept
                        or refuse cookies. If you choose to reject cookies, you
                        may still use our website though your access to some
                        functionality and areas of our website may be
                        restricted. As the means by which you can refuse cookies
                        through your web browser controls vary from browser to
                        browser, you should visit your browser's help menu for
                        more information.
                      </p>
                      <p className="text-gray-600 mb-4" data-id="element-1607">
                        In addition, most advertising networks offer you a way
                        to opt out of targeted advertising. If you would like to
                        find out more information, please visit{' '}
                        <a href="http://www.aboutads.info/choices/" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-1608">
                          http://www.aboutads.info/choices/
                        </a>{' '}
                        or{' '}
                        <a href="http://www.youronlinechoices.com" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-1609">
                          http://www.youronlinechoices.com
                        </a>
                        .
                      </p>
                      <p className="text-gray-600" data-id="element-1610">
                        You can also manage your cookie preferences through our
                        cookie consent banner that appears when you first visit
                        our website.
                      </p>
                    </div>}
                </div>
                <div className="border border-gray-200 rounded-lg" data-id="element-1611">
                  <button className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none" onClick={() => toggleSection(4)} data-id="element-1612">
                    <h3 className="font-semibold text-lg" data-id="element-1613">
                      4. Changes to Our Cookie Policy
                    </h3>
                    {expandedSection === 4 ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-1614" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-1615" />}
                  </button>
                  {expandedSection === 4 && <div className="px-6 py-4 border-t border-gray-200" data-id="element-1616">
                      <p className="text-gray-600 mb-4" data-id="element-1617">
                        We may update this Cookie Policy from time to time in
                        order to reflect, for example, changes to the cookies we
                        use or for other operational, legal, or regulatory
                        reasons. Please therefore revisit this Cookie Policy
                        regularly to stay informed about our use of cookies and
                        related technologies.
                      </p>
                      <p className="text-gray-600" data-id="element-1618">
                        The date at the top of this Cookie Policy indicates when
                        it was last updated.
                      </p>
                    </div>}
                </div>
              </div>
            </div>}
        </div>
        {/* Contact Section */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-16" data-id="element-1619">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-1620">
            <div className="mb-6 md:mb-0 md:mr-8" data-id="element-1621">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1622">Have Questions?</h2>
              <p className="text-gray-600 mb-4" data-id="element-1623">
                If you have any questions about our terms, privacy policy, or
                cookie policy, please don't hesitate to contact us.
              </p>
              <div className="flex items-center text-gray-600" data-id="element-1624">
                <MailIcon className="h-5 w-5 mr-2" data-id="element-1625" />
                <span data-id="element-1626">legal@travelsim.com</span>
              </div>
            </div>
            <div data-id="element-1627">
              <Link to="/contact" data-id="element-1628">
                <Button variant="primary" data-id="element-1629">Contact Us</Button>
              </Link>
            </div>
          </div>
        </div>
        {/* Related Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1630">
          <Link to="/refund-policy" className="bg-white rounded-xl shadow-sm p-6 hover:border-blue-200 border border-transparent transition-colors" data-id="element-1631">
            <div className="flex items-center mb-4" data-id="element-1632">
              <div className="p-3 bg-blue-100 rounded-lg mr-4" data-id="element-1633">
                <CreditCardIcon className="h-6 w-6 text-blue-600" data-id="element-1634" />
              </div>
              <h3 className="font-semibold text-lg" data-id="element-1635">Refund Policy</h3>
            </div>
            <p className="text-gray-600" data-id="element-1636">
              Learn about our refund process, eligibility criteria, and how to
              request a refund.
            </p>
          </Link>
          <Link to="/installation-guide" className="bg-white rounded-xl shadow-sm p-6 hover:border-blue-200 border border-transparent transition-colors" data-id="element-1637">
            <div className="flex items-center mb-4" data-id="element-1638">
              <div className="p-3 bg-blue-100 rounded-lg mr-4" data-id="element-1639">
                <SmartphoneIcon className="h-6 w-6 text-blue-600" data-id="element-1640" />
              </div>
              <h3 className="font-semibold text-lg" data-id="element-1641">Installation Guide</h3>
            </div>
            <p className="text-gray-600" data-id="element-1642">
              Step-by-step instructions for installing and activating your eSIM
              on different devices.
            </p>
          </Link>
          <Link to="/help" className="bg-white rounded-xl shadow-sm p-6 hover:border-blue-200 border border-transparent transition-colors" data-id="element-1643">
            <div className="flex items-center mb-4" data-id="element-1644">
              <div className="p-3 bg-blue-100 rounded-lg mr-4" data-id="element-1645">
                <LockIcon className="h-6 w-6 text-blue-600" data-id="element-1646" />
              </div>
              <h3 className="font-semibold text-lg" data-id="element-1647">Help Center</h3>
            </div>
            <p className="text-gray-600" data-id="element-1648">
              Find answers to common questions about our services, technical
              support, and more.
            </p>
          </Link>
        </div>
      </div>
    </main>;
}